import Api from '../../../services/Api';

export default {
  namespaced: true,
  state: {
    aggregateInfo: [
      { Agronomía: { analyzed: 0, in_process: 0 } },
      { Alimentaria: { analyzed: 0, in_process: 0 } },
      { 'Medio Ambiente': { analyzed: 0, in_process: 0 } },
      { Minería: { analyzed: 0, in_process: 0 } },
      { 'Salud y Seguridad': { analyzed: 0, in_process: 0 } },
    ],
    reportSampleId: '',
    reportSampleCode: '',
    currentSample: null,
    disableContext: false,
    allFilterParams: {},
    last_sample_id: null,
    isDownloadingReport: false,
    sampleFetchedFromEtl: false,
    sampleDetailReloadInProgress: false,
    lastRouteHome: false,
    lastRouteEnvStats: false,
    lastRouteGeotoolboxSamples: false,
    lastRouteIssuedInvoicesList: false,
  },
  actions: {
    setDisableContext({ commit }, value) {
      commit('setDisableContext', value);
    },
    async getSamplesWithParameters(
      { rootState, state },
      monitoring = null
    ) {
      try {
        const STATUS_FINISHED = '3';
        const extraParams = monitoring != null ? { monitoring } : {};
        const excelStatus =
          monitoring !== true ? { status: STATUS_FINISHED } : {};

        const xhr = await Api.getSamplesWithParametersData(
          {
            ...state.allFilterParams,
            ...extraParams,
            ...excelStatus,
          },
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        return Promise.resolve(response[0].Samples);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSamplesZip({ rootState }, downloadParams = null) {
      try {
        const xhr = await Api.getSamplesReports(
          downloadParams || rootState.samples.allFilterParams,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setAllFilterParams({ commit }, value) {
      commit('setAllFilterParams', value);
    },
    async getAggregateInfo({ commit, rootState }) {
      try {
        const xhr = await Api.getAggregateInfo(
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);
        commit('SET_AGGREGATEINFO', response.atc_data || []);
        return Promise.resolve(response);
      } catch (error) {
        commit('SET_AGGREGATEINFO_ERROR');
        return Promise.reject(error);
      }
    },
    getCurrentSampleBasedOnFilter({ state }) {
      return state.currentSample;
    },
    async getCurrentSample({ commit, rootState, dispatch }) {
      try {
        const xhr = await Api.getSampleInfo(
          rootState.filter.currentSampleId,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        dispatch('setReportSampleId', response.sample_id);
        dispatch(
          'setReportSampleCode',
          response.sample_code ?? response.code ?? response.CodMuestra
        );
        dispatch(
          'foodSamples/setIsNoRp',
          response.value_report === 'CMA',
          {
            root: true,
          }
        );
        commit('setCurrentSample', response);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getCurrentSampleByCode(
      { commit, state, rootState, dispatch },
      scope = null
    ) {
      try {
        // Se obtienen los detalles de la muestra por su código y no por ID interno de MongoDB
        const companyCode =
          scope?.companyCode ?? rootState.contact.company;
        const addressCode =
          scope?.addressCode ?? rootState.contact.address;
        const xhrCode = await Api.getSampleInfoByCode(
          state.reportSampleCode,
          companyCode,
          addressCode
        );

        const response = JSON.parse(xhrCode.response);

        dispatch('setReportSampleId', response.sample_id);
        dispatch(
          'setReportSampleCode',
          response.sample_code ?? response.code ?? response.CodMuestra
        );
        dispatch(
          'foodSamples/setIsNoRp',
          response.value_report === 'CMA',
          {
            root: true,
          }
        );
        commit('setCurrentSample', response);
        // Devolvemos los detalles de la muestra para acceder a la página de detalle muestra correspondiente
        return response;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getReport({ state }, docType = 1) {
      try {
        const hasValidReportSampleCode =
          state.reportSampleCode !== undefined &&
          state.reportSampleCode !== null &&
          String(state.reportSampleCode).trim() !== '';
        let reportIdentifier = { sampleId: state.reportSampleId };

        // `reportSampleId` se reutiliza como contenedor genérico en el store:
        // puede guardar sample_id, study_id o parcel_id según el flujo.
        // Aquí lo reetiquetamos antes de delegar en Api.getSampleReport.
        if ([1, 2].includes(docType)) {
          reportIdentifier = hasValidReportSampleCode
            ? {
                sampleCode: state.reportSampleCode,
                sampleId: state.reportSampleId,
              }
            : { sampleId: state.reportSampleId };
        } else if (docType === 3) {
          reportIdentifier = { studyId: state.reportSampleId };
        } else if (docType === 4) {
          reportIdentifier = { parcelId: state.reportSampleId };
        }

        const xhr = await Api.getSampleReport(
          reportIdentifier,
          docType
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve({
          name: response.data[0].nombreDocumento,
          pdfB64: response.data[0].documento,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSampleById({ rootState }, id) {
      try {
        const xhr = await Api.getSampleInfo(
          id,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setReportSampleId({ commit }, value) {
      commit('setReportSampleId', value);
    },
    setReportSampleCode({ commit }, value) {
      commit('setReportSampleCode', value);
    },
    async getSampleFilter(
      { rootState },
      { atc, attribute, sampleId, farm, parcel, valueReport }
    ) {
      try {
        const xhr = await Api.getAttributeList(
          atc,
          attribute,
          sampleId,
          farm,
          parcel,
          valueReport,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSampleFilterGeotoolbox(
      { rootState },
      { atc, attribute, sampleId, sampleTypeForGeometry }
    ) {
      try {
        const xhr = await Api.getAttributeListGeotoolbox(
          atc,
          attribute,
          sampleId,
          sampleTypeForGeometry,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSampleFilterPhytomonitoring(
      { rootState },
      { atc, attribute, sampleId, sampleTypeForGeometry }
    ) {
      try {
        const xhr = await Api.getAttributeListPhytomonitoring(
          atc,
          attribute,
          sampleId,
          sampleTypeForGeometry,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSampleFarms({ rootState }, { atc }) {
      try {
        const xhr = await Api.getSamplesFarms(
          atc,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getSampleParcels({ rootState }, { atc, farm }) {
      try {
        const xhr = await Api.getSamplesParcels(
          atc,
          farm,
          rootState.contact.company,
          rootState.contact.address
        );
        const response = JSON.parse(xhr.response);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setCurrentSample({ commit }, value) {
      commit('setCurrentSample', value);
    },
    async getLastSampleId({ rootState, commit }, parcelId) {
      try {
        const xhr = await Api.getLastSampleId(
          parcelId,
          rootState.contact.company,
          rootState.contact.address
        );

        const response = JSON.parse(xhr.response);

        commit('setLastSampleId', response ?? null);
        if (response?.sample_code) {
          commit('setReportSampleCode', response.sample_code);
        }
        if (response?.sample_id) {
          commit('setReportSampleId', response.sample_id);
        }

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setIsDownloadingReport({ commit }, value) {
      commit('setIsDownloadingReport', value);
    },
    setSampleFetchedFromEtl({ commit }, value) {
      commit('SET_SAMPLE_FETCHED_FROM_ETL', value);
    },
    setSampleDetailReloadInProgress({ commit }, value) {
      commit('SET_SAMPLE_DETAIL_RELOAD_IN_PROGRESS', value);
    },
    setLastRouteHome({ commit }, value) {
      commit('SET_LAST_ROUTE_HOME', value);
    },
    setLastRouteEnvStats({ commit }, value) {
      commit('SET_LAST_ROUTE_ENV_STATS', value);
    },
    setLastRouteGeotoolboxSamples({ commit }, value) {
      commit('SET_LAST_ROUTE_GEOTOOLBOX', value);
    },
    setLastRouteIssuedInvoicesList({ commit }, value) {
      commit('SET_LAST_ROUTE_ISSUED_INVOICES', value);
    },
  },
  mutations: {
    SET_AGGREGATEINFO(state, value) {
      state.aggregateInfo = value;
    },
    SET_AGGREGATEINFO_ERROR(state) {
      state.aggregateInfo = [
        { Agronomía: { analyzed: 0, in_process: 0 } },
        { Alimentaria: { analyzed: 0, in_process: 0 } },
        { 'Medio Ambiente': { analyzed: 0, in_process: 0 } },
        { Minería: { analyzed: 0, in_process: 0 } },
        { 'Salud y Seguridad': { analyzed: 0, in_process: 0 } },
      ];
    },
    setReportSampleId(state, value) {
      state.reportSampleId = value;
    },
    setCurrentSample(state, value) {
      state.currentSample = value;
    },
    setAllFilterParams(state, value) {
      state.allFilterParams = value;
    },
    setReportSampleCode(state, value) {
      state.reportSampleCode = value;
    },
    setDisableContext(state, value) {
      state.disableContext = value;
    },
    setLastSampleId(state, value) {
      state.last_sample_id = value;
    },
    setIsDownloadingReport(state, value) {
      state.isDownloadingReport = value;
    },
    SET_SAMPLE_FETCHED_FROM_ETL(state, value) {
      state.sampleFetchedFromEtl = value;
    },
    SET_SAMPLE_DETAIL_RELOAD_IN_PROGRESS(state, value) {
      state.sampleDetailReloadInProgress = value;
    },
    SET_LAST_ROUTE_HOME(state, value) {
      state.lastRouteHome = value;
    },
    SET_LAST_ROUTE_ENV_STATS(state, value) {
      state.lastRouteEnvStats = value;
    },
    SET_LAST_ROUTE_GEOTOOLBOX(state, value) {
      state.lastRouteGeotoolboxSamples = value;
    },
    SET_LAST_ROUTE_ISSUED_INVOICES(state, value) {
      state.lastRouteIssuedInvoicesList = value;
    },
  },
};
